import { useField } from 'formik'
import { Cursor04 } from 'blaze-ui/icons'
import { Field } from './Field'
import { Input } from 'almanac-ui/TextInputField/Input'

export const CallToActionField = ({ name = 'callToAction' }: { name?: string }) => {
  const [field, meta, helpers] = useField<string>(name)

  return (
    <Field icon={Cursor04} label="Call-to-Action">
      <Input
        isTextarea
        value={field.value}
        onChange={(e) => helpers.setValue(e.target.value)}
        placeholder="Enter a call to action for the campaign"
        isValid={!meta.touched || !meta.error}
        errorMessage={meta.touched && meta.error}
        name="callToAction"
      />
    </Field>
  )
}
